import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicCondInput from "components/BasicInputs/BasicCondInput";
import SwitchableTextInput from "components/BasicInputs/SwitchableTextInput";
import Inline from "./Inline";
import {createContext} from "react";
import {TextField} from "@mui/material";
import Custom from "./Custom";

export const comps = {
    select: BasicSelect,
    text: BasicTextInput,
    textField: TextField,
    date: BasicDateInput,
    cond: BasicCondInput,
    inline: Inline,
    custom: Custom,
    "text-switchable": SwitchableTextInput,
};

// export const FormContext = createContext({});

export default function RenderInput(input: FormInput) {
    const Comp = (comps as any)[input.type];
    if (!Comp) return <></>;
    return (
        <div className={input?.containerClassName}>
            <Comp {...input} {...input.inputProps} {...input.fieldProps} />
        </div>
    );
}
